import { render, staticRenderFns } from "./TableDetallesApelacion.vue?vue&type=template&id=53488792&"
import script from "./TableDetallesApelacion.vue?vue&type=script&lang=js&"
export * from "./TableDetallesApelacion.vue?vue&type=script&lang=js&"
import style0 from "./TableDetallesApelacion.vue?vue&type=style&index=0&id=53488792&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports